<template>
  <el-table
    border
    size="small"
    width="100%"
    :data="pdfData"
    :span-method="objectSpanMethod"
    :header-cell-class-name="headerCellClass"
    :cell-style="cellStyle"
    :id="'listTable' + index"
    :row-class-name="rowClassName"
  >
    <el-table-column
      v-for="(item, idx) in header"
      :resizable="false"
      :label="item.label"
      :min-width="item.width"
      header-align="center"
      :align="item.align"
      :prop="item.prop"
      :key="idx"
      :formatter="item.formatter"
    ></el-table-column>
  </el-table>
</template>

<script>
export default {
  name: "item-list-table",
  props: {
    header: {
      type: Array,
      required: true,
      default: () => [],
    },
    pdfData: {
      type: Array,
      required: true,
      default: () => [],
    },
    index: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data() {
    return {};
  },
  methods: {
    rowClassName({ row }) {
      if (row.subTotal) {
        return "sub-total";
      } else if (row.allTotal) {
        return "all-total";
      }
    },
    headerCellClass({ columnIndex }) {
      if (columnIndex === 1 || columnIndex === 3 || columnIndex === 6) {
        return "justify";
      }
    },
    cellStyle({ rowIndex }) {
      if (this.pdfData[rowIndex + 1] && this.pdfData[rowIndex + 1].filmSearchId.indexOf(this.$locale("global.total")) > -1) {
        return "border-bottom: 3px double;";
      }
    },
    objectSpanMethod({ row, columnIndex }) {
      if(row.filmSearchId.indexOf(this.$locale("global.total")) > -1) {
        if(columnIndex === 0) {
          return {
            rowspan: 1,
            colspan: 6,
          };
        }
        if (columnIndex > 0 && columnIndex < 6) {
          return {
            rowspan: 1,
            colspan: 0,
          };
        }
      }
      return {
        rowspan: 1,
        colspan: 1,
      };
    },
  },
};
</script>
